import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ContainerDetails.styles";
import SecureSyncTable from "src/components/common/SecureSyncTable/SecureSyncTable";
import SecureSyncTableCard from "src/components/common/SecureSyncTableCard/SecureSyncTableCard";
import { sortHelper } from "src/utils/sortHelper";
import { convertToLocaleUpperCase } from "src/utils/commonHelper";

const ContainerDetails = ({ requestContainerDetails }) => {
    const { t } = useTranslation();
    const columns = useMemo(() => {
        const baseColumns = [
            { field: "number", headerName: convertToLocaleUpperCase(t("tableHeader.containerNumber")) },
            { field: "descr", headerName: convertToLocaleUpperCase(t("tableHeader.containerType")) },
            { field: "exchange_status", headerName: convertToLocaleUpperCase(t("tableHeader.containerStatus")) },
        ];
        return baseColumns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const sortedRequestContainerDetails = sortHelper({
        data: requestContainerDetails,
        primaryProperty: "logical_vault_id",
        secondaryProperty: "exchange_status",
        thirdProperty: "number",
        sortOrder: "asc",
    });
    return (
        <>
            <SecureSyncTableCard>
                <Box sx={styles.recordCount}>
                    <Typography variant="h6" sx={styles.heading}>
                        {t("requestDetails.containerDetails")}
                    </Typography>
                    {requestContainerDetails?.length > 0 && (
                        <>
                            <Box sx={styles.recordStart}>
                                <Typography variant="body1">
                                    {t("messages.recordsFound", { count: requestContainerDetails?.length })}
                                </Typography>
                            </Box>
                        </>
                    )}
                </Box>
                <Box sx={styles.cardContent}>
                    <SecureSyncTable
                        rows={sortedRequestContainerDetails}
                        columns={columns}
                        noDataMessage={t("messages.noContainersAreAssociated")}
                        getRowId={(row) => row.id}
                        initialRowsPerPage={25}
                    />
                </Box>
            </SecureSyncTableCard>
        </>
    );
};

export default ContainerDetails;
